import { Action } from 'redux';

import { DeleteForeverContents, DeleteForeverContentsSucceeded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface DeleteForeverContentAction extends Action {
  contentArray: IContentInfo[];
}

export function deleteForeverContentsAction(contentArray: IContentInfo[]): DeleteForeverContentAction {
  return {
    type: DeleteForeverContents,
    contentArray: contentArray
  };
}

export function deleteForeverContentAction(content: IContentInfo): DeleteForeverContentAction {
  return deleteForeverContentsAction([content]);
}

export interface DeleteForeverContentSucceededAction extends Action {}


export const isDeleteForeverContentAction = isActionFactory<DeleteForeverContentAction>(DeleteForeverContents);

export function deleteForeverContentSucceeded(): DeleteForeverContentSucceededAction {
  return {
    type: DeleteForeverContentsSucceeded
  };
}

export const isDeleteForeverContentSucceeded = isActionFactory<DeleteForeverContentSucceededAction>(DeleteForeverContentsSucceeded);
